import React from 'react';
import { formatCurrency } from 'utils';
import { Stack, Typography } from '@mui/material';

import { QuoteChargeCalcResult, QuoteChargeColumnTotals } from '../../../../types';

interface Props {
  priceCalc: QuoteChargeCalcResult;
  field: keyof QuoteChargeColumnTotals;
}

export const EquipmentChargeColumnTotalCell = ({ field, priceCalc }: Props) => {
  return (
    <Stack>
      <Typography>Total: {formatCurrency(priceCalc.totals.columnTotals[field] ?? null, true)}</Typography>
    </Stack>
  );
};
